"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClassInstance = exports.Class = exports.BaseInstance = void 0;
const callable_1 = require("./callable");
const error_1 = require("./error");
class BaseInstance extends callable_1.Callable {
    get(interpreter, name) {
        throw new Error('Method not implemented.');
    }
}
exports.BaseInstance = BaseInstance;
class Class extends BaseInstance {
    constructor(name, methods, superclass) {
        super();
        this.name = name;
        this.methods = methods;
        this.superclass = superclass;
    }
    findMethod(name) {
        var _a;
        return this.methods.get(name) || ((_a = this.superclass) === null || _a === void 0 ? void 0 : _a.findMethod(name));
    }
    get(interpreter, name) {
        const method = this.findMethod(name.lexeme);
        if (method !== undefined) {
            return method;
        }
        throw new error_1.RuntimeError(name, `Undefined property '${name.lexeme}'`);
    }
    arity() {
        var _a, _b;
        return (_b = (_a = this.findMethod('init')) === null || _a === void 0 ? void 0 : _a.arity()) !== null && _b !== void 0 ? _b : 0;
    }
    call(interpreter, args) {
        const instance = new ClassInstance(this);
        const initializer = this.findMethod('init');
        if (initializer !== undefined) {
            initializer.bind(instance).call(interpreter, args);
        }
        return instance;
    }
}
exports.Class = Class;
class ClassInstance extends BaseInstance {
    constructor(clazz) {
        super();
        this.clazz = clazz;
        this.fields = new Map();
    }
    get(interpreter, name) {
        if (this.fields.has(name.lexeme)) {
            return this.fields.get(name.lexeme);
        }
        const method = this.clazz.findMethod(name.lexeme);
        if (method !== undefined) {
            const boundMethod = method.bind(this);
            return method.isGetter ? boundMethod.call(interpreter, []) : boundMethod;
        }
        throw new error_1.RuntimeError(name, `Undefined property '${name.lexeme}'.`);
    }
    set(name, value) {
        this.fields.set(name.lexeme, value);
    }
}
exports.ClassInstance = ClassInstance;
